import {
  Circle,
  MousePointer2,
  RotateCcw,
  Slash,
  Square,
  Trash2,
  Triangle,
  Type,
  Image,
  Component,
  Cog,
  Spline,
  Undo,
  Redo,
} from "lucide-react";

export const shapeElements = [
  {
    icon: Square,
    name: "Rectangle",
    value: "rectangle",
  },
  {
    icon: Circle,
    name: "Circle",
    value: "circle",
  },
  {
    icon: Triangle,
    name: "Triangle",
    value: "triangle",
  },
  {
    icon: Slash,
    name: "Line",
    value: "line",
  },
  {
    icon: Image,
    name: "Image",
    value: "image",
  },
  {
    icon: Component,
    name: "SVG",
    value: "svg",
  },
];

export const navElements = [
  {
    icon: MousePointer2,
    name: "Select",
    value: "select",
  },
  {
    icon: Square,
    name: "Elements Menu",
    value: shapeElements,
  },

  {
    icon: Type,
    name: "Text",
    value: "text",
  },
  {
    icon: Spline,
    name: "Curved Text",
    value: "curvedText",
  },
  {
    icon: Trash2,
    name: "Delete Selected",
    value: "delete",
  },
  {
    icon: RotateCcw,
    name: "Reset",
    value: "reset",
  },
  {
    icon: Cog,
    name: "Template Settings",
    value: "settings",
  },

  {
    icon: Undo,
    name: "Undo",
    value: "undo",
  },

  {
    icon: Redo,
    name: "Redo",
    value: "redo",
  },
];

export const defaultNavElement = {
  icon: MousePointer2,
  name: "Select",
  value: "select",
};

export const fontWeightOptions = [
  {
    value: "400",
    label: "Normal",
  },
  {
    value: "600",
    label: "Semibold",
  },
  {
    value: "700",
    label: "Bold",
  },
];

// locks

const textConsumerLocksItems = [
  {
    key: "position",
    title: "Position",
    defaultValue: true,
    type: "boolean",
  },
  {
    key: "text",
    title: "Text Value",
    defaultValue: true,
    type: "boolean",
  },
  {
    key: "minTextLength",
    title: "Min Text Length",
    defaultValue: 0,
    type: "number",
  },
  {
    key: "maxTextLength",
    title: "Max Text Length",
    defaultValue: 22,
    type: "number",
  },
  {
    key: "fontFamily",
    title: "Font Family",
    defaultValue: true,
    type: "boolean",
  },
  {
    key: "fontSize",
    title: "Font Size",
    defaultValue: true,
    type: "boolean",
  },
  {
    key: "fontWeight",
    title: "Font Weight",
    defaultValue: true,
    type: "boolean",
  },

  {
    key: "fill",
    title: "Fill Color",
    defaultValue: true,
    type: "boolean",
  },

  {
    key: "strokeWidth",
    title: "Stroke Width",
    defaultValue: true,
    type: "boolean",
  },

  {
    key: "stroke",
    title: "Stroke Color",
    defaultValue: true,
    type: "boolean",
  },
  {
    key: "rotation",
    title: "Rotation",
    defaultValue: true,
    type: "boolean",
  },

  {
    key: "updateTextInPlace",
    title: "Update Text In Place",
    defaultValue: true,
    type: "boolean",
  },

  {
    key: "updateTextFontSizeInPlace",
    title: "Update Text Font Size In Place",
    defaultValue: true,
    type: "boolean",
  },

  {
    key: "updateTextFontFamilyInPlace",
    title: "Update Text Font Family In Place",
    defaultValue: true,
    type: "boolean",
  },

  {
    key: "all",
    title: "All Locks",
    defaultValue: true,
    type: "boolean",
  },
];

const curvedTextConsumerLocksItems = [
  {
    key: "position",
    title: "Position",
    defaultValue: true,
    type: "boolean",
  },
  {
    key: "text",
    title: "Text Value",
    defaultValue: true,
    type: "boolean",
  },
  {
    key: "minTextLength",
    title: "Min Text Length",
    defaultValue: 0,
    type: "number",
  },
  {
    key: "maxTextLength",
    title: "Max Text Length",
    defaultValue: 22,
    type: "number",
  },
  {
    key: "fontFamily",
    title: "Font Family",
    defaultValue: true,
    type: "boolean",
  },
  {
    key: "fontSize",
    title: "Font Size",
    defaultValue: true,
    type: "boolean",
  },
  {
    key: "fontWeight",
    title: "Font Weight",
    defaultValue: true,
    type: "boolean",
  },

  {
    key: "fill",
    title: "Fill Color",
    defaultValue: true,
    type: "boolean",
  },

  {
    key: "strokeWidth",
    title: "Stroke Width",
    defaultValue: true,
    type: "boolean",
  },

  {
    key: "stroke",
    title: "Stroke Color",
    defaultValue: true,
    type: "boolean",
  },
  {
    key: "rotation",
    title: "Rotation",
    defaultValue: true,
    type: "boolean",
  },

  {
    key: "updateTextInPlace",
    title: "Update Text In Place",
    defaultValue: true,
    type: "boolean",
  },

  // curvature settings
  // default are locked, since most time we don't want the consumer to change them.
  {
    key: "diameter",
    title: "Diameter",
    defaultValue: true,
    type: "boolean",
  },
  {
    key: "arcAngle",
    title: "Arc Angle",
    defaultValue: true,
    type: "boolean",
  },
  {
    key: "startAngle",
    title: "Start Angle",
    defaultValue: true,
    type: "boolean",
  },
  {
    key: "all",
    title: "All Locks",
    defaultValue: true,
    type: "boolean",
  },
];

const shapeConsumerLocksItems = [
  {
    key: "position",
    title: "Position",
    defaultValue: true,
    type: "boolean",
  },
  {
    key: "size",
    title: "Size",
    defaultValue: true,
    type: "boolean",
  },
  // color stuff
  {
    key: "fill",
    title: "Fill Color",
    defaultValue: true,
    type: "boolean",
  },
  {
    key: "strokeWidth",
    title: "Stroke Width",
    defaultValue: true,
    type: "boolean",
  },
  {
    key: "stroke",
    title: "Stroke Color",
    defaultValue: true,
    type: "boolean",
  },
  {
    key: "rotation",
    title: "Rotation",
    defaultValue: true,
    type: "boolean",
  },
  {
    key: "all",
    title: "All Locks",
    defaultValue: true,
    type: "boolean",
  },
];

const groupConsumerLocksItems = [
  {
    key: "position",
    title: "Position",
    defaultValue: true,
    type: "boolean",
  },
  {
    key: "size",
    title: "Size",
    defaultValue: true,
    type: "boolean",
  },

  {
    key: "rotation",
    title: "Rotation",
    defaultValue: true,
    type: "boolean",
  },
  {
    key: "all",
    title: "All Locks",
    defaultValue: true,
    type: "boolean",
  },
];

// will be used in menus.
export const getConsumerLocksItems = (type: string) => {
  switch (type) {
    case "i-text":
      return textConsumerLocksItems;

    case "curved-text":
      return curvedTextConsumerLocksItems;

    case "group":
      return groupConsumerLocksItems;

    default:
      return shapeConsumerLocksItems;
  }
};

export const getConsumerLockMenuTitle = (type: string, key: string) => {
  switch (type) {
    case "i-text":
      return textConsumerLocksItems.find((item) => item.key === key)?.title;

    case "curved-text":
      return curvedTextConsumerLocksItems.find((item) => item.key === key)
        ?.title;

    case "group":
      return groupConsumerLocksItems.find((item) => item.key === key)?.title;

    default:
      return shapeConsumerLocksItems.find((item) => item.key === key)?.title;
  }
};

export const getConsumerLockMenuType = (type: string, key: string) => {
  switch (type) {
    case "i-text":
      return textConsumerLocksItems.find((item) => item.key === key)?.type;

    case "curved-text":
      return curvedTextConsumerLocksItems.find((item) => item.key === key)
        ?.type;

    case "group":
      return groupConsumerLocksItems.find((item) => item.key === key)?.type;

    default:
      return shapeConsumerLocksItems.find((item) => item.key === key)?.type;
  }
};

// this will be inside canvas object consumer locks object.
export const getConsumerLocksObject = (type: string) => {
  switch (type) {
    case "i-text":
      const textConsumerLocksObject = {} as any;

      textConsumerLocksItems.forEach((item) => {
        textConsumerLocksObject[item.key] = item.defaultValue;
      });

      return textConsumerLocksObject;

    case "curved-text":
      const curvedTextConsumerLocksObject = {} as any;

      curvedTextConsumerLocksItems.forEach((item) => {
        curvedTextConsumerLocksObject[item.key] = item.defaultValue;
      });

      return curvedTextConsumerLocksObject;

    case "group":
      const groupConsumerLocksObject = {} as any;

      groupConsumerLocksItems.forEach((item) => {
        groupConsumerLocksObject[item.key] = item.defaultValue;
      });

      return groupConsumerLocksObject;

    default:
      const shapeConsumerLocksObject = {} as any;
      shapeConsumerLocksItems.forEach((item) => {
        shapeConsumerLocksObject[item.key] = item.defaultValue;
      });

      return shapeConsumerLocksObject;
  }
};

export const TO_JSON_ADDITIONAL_PROPERTIES = [
  "objectId",
  "type",
  "consumerLocks",
  "layerName", // new for user friendly layer names in consumer frontend.
];
